import { SVGProps, Ref, forwardRef } from 'react';

export const ExclamationTriangleFilledSize32Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.459 22.73 11.35 6.848C13.409 3.172 14.438 1.333 16 1.333s2.59 1.839 4.65 5.515L29.54 22.73c1.98 3.534 2.968 5.3 2.197 6.619-.773 1.318-2.797 1.318-6.846 1.318H7.108c-4.049 0-6.073 0-6.845-1.318s.217-3.085 2.196-6.62m12.354-2.197v-10h2.4v10zm1.2 2a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.334"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ExclamationTriangleFilledSize32Glyph.displayName = 'ExclamationTriangleFilledSize32Glyph';
